var Handlebars = require("../../../../../node_modules/.pnpm/handlebars@4.7.10/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"leaflet-popup-greenfield-row\">\n        <span class=\"leaflet-popup-greenfield-title\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Greenfield.Pma",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":8,"column":53},"end":{"line":8,"column":78}}}))
    + ":</span>\n        <span>"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"PmaName") : depth0), depth0))
    + "</span>\n    </div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"leaflet-popup-greenfield-row\">\n        <span class=\"leaflet-popup-greenfield-title\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Greenfield.Tier",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":14,"column":53},"end":{"line":14,"column":79}}}))
    + ":</span>\n        <span>"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"TierText") : depth0), depth0))
    + "</span>\n    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"leaflet-popup-greenfield-row\">\n        <span class=\"leaflet-popup-greenfield-title\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Greenfield.Format",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":20,"column":53},"end":{"line":20,"column":81}}}))
    + ":</span>\n        <span>"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"PointTypeTag") : depth0), depth0))
    + "</span>\n    </div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <div class=\"leaflet-popup-greenfield-row\">\n        <span class=\"leaflet-popup-greenfield-title\">"
    + alias1(__default(require("./i18n.js")).call(depth0 != null ? depth0 : (container.nullContext || {}),"Greenfield.Year",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":26,"column":53},"end":{"line":26,"column":79}}}))
    + ":</span>\n        <span>"
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"YearReference") : depth0), depth0))
    + "</span>\n    </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div>\n    <div class=\"leaflet-popup-greenfield-header\">\n        <img src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"PinIcon") : depth0), depth0))
    + "\">\n        <span>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"PointName") : depth0), depth0))
    + "</span>\n    </div>\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"PmaName") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":11,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"TierText") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":4},"end":{"line":17,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"PointTypeTag") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":18,"column":4},"end":{"line":23,"column":11}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"YearReference") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":4},"end":{"line":29,"column":11}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/scripts/core/templates/templates/map-layer-greenfield-popup.hbs
// module id = Aj6y
// module chunks = 1